module.exports = __webpack_public_path__ + "static/media/loader.7bbee273.svg";